export function customSelect() {
    $(window).on("load", () => {
        jcf.setOptions("Select", {
            wrapNative: false,
            wrapNativeOnMobile: true,
            fakeDropInBody: false,
            maxVisibleItems: 4,
            useCustomScroll: true
        });
        jcf.replaceAll();
        setTimeout(function () {
            jcf.destroy($(".lang-switcher select"));
        }, 100);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/custom-select.js